<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5" v-if="contrato">
                            {{ contrato.codContrato }}
                            <b-button
                                variant="danger"
                                @click.stop="voltar()"
                                class="float-right btn-sm"
                                v-if="mostrarBtnVoltar"
                            >
                                <span>
                                    <i class="fa fa-history"></i> Voltar à lista
                                    de contratos
                                </span>
                            </b-button>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <div v-if="contrato">
                            <app-k-v
                                titulo="Objeto"
                                :md="3"
                                :lg="2"
                                :xl="1"
                                :dado="contrato.objeto"
                            ></app-k-v>
                            <app-k-v titulo="Vigência" :md="3" :lg="2" :xl="1"
                                ><strong
                                    >{{
                                        $moment(contrato.inicioVigencia).format(
                                            'DD/MM/YYYY'
                                        )
                                    }}
                                    -
                                    {{
                                        $moment(contrato.fimVigencia).format(
                                            'DD/MM/YYYY'
                                        )
                                    }}</strong
                                ></app-k-v
                            >
                            <app-k-v
                                titulo="Valor Total"
                                :md="3"
                                :lg="2"
                                :xl="1"
                                ><strong>{{
                                    contrato.valorTotal | currency
                                }}</strong></app-k-v
                            >
                            <!-- <app-k-v titulo="Saldo" :md="3" :lg="2" :xl="1"
                                ><strong>{{
                                    contrato.saldo | currency
                                }}</strong></app-k-v
                            > -->
                            <app-k-v
                                titulo="Gestor"
                                :md="3"
                                :lg="2"
                                :xl="1"
                                :dado="contrato.gestor"
                            ></app-k-v>
                            <app-k-v titulo="Aditivos" :md="3" :lg="2" :xl="1"
                                ><strong>{{
                                    contrato.aditivos
                                }}</strong></app-k-v
                            >
                            <app-k-v titulo="Status" :md="3" :lg="2" :xl="1"
                                ><app-status
                                    :status="contrato.status"
                                ></app-status
                            ></app-k-v>
                        </div>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <contratos-dashboard
            v-if="mostrarDashboardContrato"
        ></contratos-dashboard>
        <router-view
            v-if="contrato"
            :contrato="contrato"
            :dataServico="dataServico"
        ></router-view>
    </div>
</template>

<script>
import ContratosDashboard from './ContratosDash2'

export default {
    props: {
        contratos: {
            type: Array,
            default: () => []
        },

        dataServico: {
            type: Object,
            default: () => {}
        }
    },

    components: { ContratosDashboard },

    data() {
        return {
            erros: []
        }
    },

    methods: {
        voltar() {
            if (this.$route.name != 'FornecedoresContratos_Detalhar') {
                this.$router.push({ name: 'FornecedorContratos' })
            } else {
                this.$router.push({ name: 'FornecedoresContratos' })
            }
        }
    },

    computed: {
        contrato() {
            return this.contratos.find(
                c =>
                    c.codContrato ===
                    this.$route.params.codContrato.replace('-', '/')
            )
        },

        isRotaContratosDetalhar() {
            return (
                this.$route.name === 'FornecedoresContratos_Detalhar' ||
                this.$route.name === 'FornecedorContratos_Detalhar'
            )
        },

        mostrarDashboardContrato() {
            return this.isRotaContratosDetalhar
        },

        mostrarBtnVoltar() {
            return this.isRotaContratosDetalhar
        }
    },

    created() {},

    watch: {}
}
</script>
